import { projectImageUploadFileType } from "@/propTypes";
import { useSetDefaultProjectImageMutation } from "@/services";
import { Button, Row } from "antd";
import { node } from "prop-types";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

export const DefaultImageSelector = ({ originNode, file }) => {
  const { projectId } = useParams();
  const intl = useIntl();
  const [setDefaultProjectImage] = useSetDefaultProjectImageMutation();

  const setDefaultImage = (file) => {
    setDefaultProjectImage({ projectId: projectId, projectImageId: file.id })
      .unwrap()
      .then(() => {
        toast.success(
          intl.formatMessage(
            { id: "project.setDefaultSuccess" },
            { fileName: file.name }
          )
        );
      })
      .catch(() => {
        toast.error(
          intl.formatMessage(
            { id: "project.setDefaultError" },
            { fileName: file.name }
          )
        );
      });
  };

  return (
    <>
      <Row justify="center" className="pb-1" style={{ height: "110px" }}>
        {originNode}
      </Row>
      <Row justify="center" className="pb-1">
        {file?.isDefaultImage ? (
          <div className="text-center">
            {intl.formatMessage({ id: "general.default" })}
          </div>
        ) : (
          <Button
            data-test-id={`images-card-default-${file?.id}`}
            onClick={() => setDefaultImage(file)}
            className="w-full p-0"
          >
            {intl.formatMessage({ id: "general.makeDefault" })}
          </Button>
        )}
      </Row>
    </>
  );
};

DefaultImageSelector.propTypes = {
  originNode: node.isRequired,
  file: projectImageUploadFileType.isRequired,
};
